import { Fragment, h } from '@stencil/core';
import { CATEGORY, pesCatalogPageTypes, ConfiguratorHandler, tryParse } from '@pes-ui/utils';
import { PesRouterStore } from '../../index';
import { getFilteredBreadcrumbs } from '../breadcrumbs/utils';
import { addHostToHmcUrls } from '../UI/help-me-choose/utils';
export class PesAppCategory {
  constructor() {
    var _a;
    this.hyperPersonalizationFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.hyperPersonalization;
    this.isHyperPersonalizationEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.hyperPersonalizationFlag || {});
    this._showBreadcrumbs = undefined;
    this._categoryAllData = undefined;
    this._categoryId = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._isPBS = undefined;
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryAllData = null;
    this.categoryId = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.isPBS = true;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f;
    this.showBreadcrumbs = (_a = tryParse(this._showBreadcrumbs)) !== null && _a !== void 0 ? _a : this.showBreadcrumbs;
    this.categoryAllData = (_b = tryParse(this._categoryAllData)) !== null && _b !== void 0 ? _b : this.categoryAllData;
    this.isPBS = (_c = tryParse(this._isPBS)) !== null && _c !== void 0 ? _c : this.isPBS;
    this.categoryId = (_d = tryParse(this._categoryId)) !== null && _d !== void 0 ? _d : this.categoryId;
    this.countryCode = (_e = tryParse(this._countryCode)) !== null && _e !== void 0 ? _e : this.countryCode;
    this.languageCode = (_f = tryParse(this._languageCode)) !== null && _f !== void 0 ? _f : this.languageCode;
    if (this.isPBS)
      PesRouterStore.set('enableAppRouting', true);
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${CATEGORY}/${this.categoryId}`;
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs(this.categoryAllData.breadcrumbs.breadcrumbs, this.isPBS ? undefined : []);
  }
  get hmcBanner() {
    var _a, _b;
    if (!((_b = (_a = this.categoryAllData) === null || _a === void 0 ? void 0 : _a.mainInfo) === null || _b === void 0 ? void 0 : _b.hmcBanner)) {
      return null;
    }
    const { hmcBanner } = this.categoryAllData.mainInfo;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { breadcrumbs: { hideOnMobile }, descriptionInfo: { name, description, readLessLabel, readMoreLabel, badge = null }, mainInfo: { commonFiltersFilterBy, commonFiltersProductFiltersLabel, commonFiltersShowRanges, commonFiltersClearAllLabel, commonFiltersOfferTypeLabel, rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters, subCategories, }, } = this.categoryAllData;
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: hideOnMobile, hostWithLocale: this.storageName })), h("pes-category-heading", { name: name, description: description, readLessLabel: readLessLabel, readMoreLabel: readMoreLabel, badge: badge }), this.isHyperPersonalizationEnabled
      && (h("pes-recommendations", { class: 'category-recommendations', pageType: pesCatalogPageTypes.CATEGORY, pageId: this.categoryId, countryCode: this.countryCode, languageCode: this.languageCode, isLoggedIn: this.isPBS })), h("pes-subcategories", { name: name, sourceId: this.categoryId, commonFiltersFilterBy: commonFiltersFilterBy, commonFiltersProductFiltersLabel: commonFiltersProductFiltersLabel, commonFiltersShowRanges: commonFiltersShowRanges, commonFiltersClearAllLabel: commonFiltersClearAllLabel, commonFiltersOfferTypeLabel: commonFiltersOfferTypeLabel, rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters: newFilters, subCategories: subCategories, hmcBanner: this.hmcBanner, avoidAccents: true, isPBS: this.isPBS, categoryId: this.categoryId, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, languageCode: this.languageCode, countryCode: this.countryCode })));
  }
  static get is() { return "pes-app-category"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-app-category.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-app-category.css"]
    };
  }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_categoryAllData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-all-data",
        "reflect": false
      },
      "_categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-id",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://www.se.com:9090"
            }],
          "text": "The host of the endpoints."
        },
        "attribute": "host",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the breadcrumbs."
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "categoryAllData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TCategoryAllData",
          "resolved": "{ breadcrumbs: TBreadcrumbsData; descriptionInfo: TDescriptionInfo; mainInfo: TMainInfo; config: TConfig; recentlyViewedConfig: RecentlyViewedConfig; metaTags?: MetaTags; }",
          "references": {
            "TCategoryAllData": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Main data for category page."
        },
        "defaultValue": "null"
      },
      "categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4200"
            }],
          "text": "The ID of the category."
        },
        "attribute": "category-id",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "fr"
            }],
          "text": "The code of the country of the app."
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "it"
            }],
          "text": "The code of the language of the app."
        },
        "attribute": "language-code",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "true"
      }
    };
  }
  static get states() {
    return {
      "storageName": {},
      "currentPageStorageKey": {}
    };
  }
}
